/* eslint-disable no-undef */
import { call, put, takeEvery, all } from 'redux-saga/effects';
import { message } from 'antd';
import { fetchApiAuth, getCustomerIdFromCookie, getWordpressUserIdFromCookie } from '../utils/api';
import history from '../utils/history';

import {
    raiseInvoiceQuerySuccess,
    raiseInvoiceQueryFailure,

    raiseInvoiceQueryWpSuccess,
    raiseInvoiceQueryWpFailure,

    addInvoiceCommentWpSuccess,
    addInvoiceCommentWpFailure,

    acceptInvoiceQueryWpSuccess,
    acceptInvoiceQueryWpFailure,

    getInvoiceQueriesSuccess,
    getInvoiceQueriesFailure,

    getInvoiceQueryRequest,
    getInvoiceQuerySuccess,
    getInvoiceQueryFailure,

    postCommentSuccess,
    postCommentFailure,
} from './invoiceQueryActions';

const {
    RAISE_INVOICE_QUERY_REQUEST,
    RAISE_INVOICE_QUERY_WP_REQUEST,
    ACCEPT_INVOICE_QUERY_WP_REQUEST,
    ADD_INVOICE_COMMENT_WP_REQUEST,
    GET_INVOICE_QUERIES_REQUEST,
    GET_INVOICE_QUERY_REQUEST,
    POST_COMMENT_REQUEST,
} = require('./invoiceQueryActions').constants;

function* getInvoiceQuery({ payload }) {
    const customerId = getWordpressUserIdFromCookie();
    try {
        yield put({ type: 'SET_FETCHING', payload: true });
        const response = yield call(fetchApiAuth, {
            method: 'GET',
            url: 'invoice-query',
            params: { ...payload, customerId },
        });

        yield put(getInvoiceQuerySuccess(response.data));
    } catch (e) {
        message.error(e.response ? e.response.data.message : e);
        yield put(getInvoiceQueryFailure(e.response ? e.response.data.message : e));
    } finally {
        yield put({ type: 'SET_FETCHING', payload: false });
    }
}

// 20250819 Ragul FIX THX-252 This method accept invoice query using nonce in WP
function* acceptWPInvoiceQuery({ payload }) {
    try {
        const formData = new FormData();
        formData.append('action', 'accept_react_invoice_query');
        formData.append('_wpnonce', document.querySelector('meta[name="scorch-accept-react-nonce"]')?.content);
        formData.append('invoice_query_id', payload.invoiceQueryId);
        formData.append('react_mode', '1');

        const url = document.querySelector('meta[name="scorch-submit-url"]')?.content;

        // Wait for fetch to complete
        const response = yield call(fetch, url, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin',
        });

        const data = yield call([response, 'json']); // response.json()

        if (response.ok) {
            yield put(acceptInvoiceQueryWpSuccess(data));
            if (data?.data?.message?.includes('invalid') || data?.data?.message?.includes('Error')) {
                message.error('Invalid Invoice');
            } else {
                history.push('/account/invoice-queries/');
                message.success(data?.data?.message || 'Query Accepted successfully');
            }
        } else {
            throw new Error(data?.message || 'Something went wrong');
        }
    } catch (e) {
        message.error(e.message || 'Failed to raise invoice query');
        yield put(acceptInvoiceQueryWpFailure(e.message || e));
    }
}

// 20250819 Ragul FIX THX-252 This method add comments to invoice query using nonce in WP
function* addWPInvoiceComments({ payload }) {
    try {
        const formData = new FormData();
        formData.append('action', 'add_react_invoice_query_comment');
        formData.append('_wpnonce', document.querySelector('meta[name="scorch-add-react-nonce"]')?.content);
        formData.append('invoice_query_id', payload.invoiceQueryId);
        formData.append('note', payload.comment);
        formData.append('react_mode', '1');

        const url = document.querySelector('meta[name="scorch-submit-url"]')?.content;

        // Wait for fetch to complete
        const response = yield call(fetch, url, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin',
        });

        const data = yield call([response, 'json']); // response.json()

        if (response.ok) {
            if (data?.data?.message?.includes('invalid') || data?.data?.message?.includes('Error')) {
                message.error('Invalid Invoice');
            } else {
                yield put(addInvoiceCommentWpSuccess(data));
                message.success(data?.data?.message || 'Comments Added successfully');
                yield put(getInvoiceQueryRequest({ invoiceId: payload.invoiceQueryId }));
            }
        } else {
            throw new Error(data?.message || 'Something went wrong');
        }
    } catch (e) {
        message.error(e.message || 'Failed to raise invoice query');
        yield put(addInvoiceCommentWpFailure(e.message || e));
    }
}

// 20250819 Ragul FIX THX-252 This method raise invoice query using nonce in WP
function* raiseWPInvoiceQuery({ payload }) {
    try {
        const formData = new FormData();
        formData.append('action', 'submit_react_invoice_query');
        formData.append('_wpnonce', document.querySelector('meta[name="scorch-submit-react-nonce"]')?.content);
        formData.append('invoice_id', payload.invoiceId);
        formData.append('query_type', payload.queryType);
        formData.append('notes', payload.queryNotes);
        formData.append('react_mode', '1');

        const url = document.querySelector('meta[name="scorch-submit-url"]')?.content;

        // Wait for fetch to complete
        const response = yield call(fetch, url, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin',
        });

        const data = yield call([response, 'json']); // response.json()

        if (response.ok) {
            yield put(raiseInvoiceQueryWpSuccess(data));
            if (data?.data?.message?.includes('invalid') || data?.data?.message?.includes('Error')) {
                message.error('Invalid Invoice');
            } else {
                history.push('/account/invoice-queries/');
                message.success(data?.data?.message || 'Invoice query raised successfully');
            }
        } else {
            throw new Error(data?.message || 'Something went wrong');
        }
    } catch (e) {
        message.error(e.message || 'Failed to raise invoice query');
        yield put(raiseInvoiceQueryWpFailure(e.message || e));
    }
}

function* raiseInvoiceQuery({ payload }) {
    const customerId = getCustomerIdFromCookie();
    try {
        const response = yield call(fetchApiAuth, {
            method: 'POST',
            url: 'invoice-query',
            body: { ...payload, customerId },
        });

        yield put(raiseInvoiceQuerySuccess(response));
        message.success('Invoice query raised successfully');
    } catch (e) {
        message.error(e.response ? e.response.data.message : e);
        yield put(raiseInvoiceQueryFailure(e.response ? e.response.data.message : e));
    }
}

function* getInvoiceQueries({ payload }) {
    const customerId = getWordpressUserIdFromCookie();
    try {
        const response = yield call(fetchApiAuth, {
            method: 'GET',
            url: 'invoice-query',
            params: { ...payload, customerId },
        });

        yield put(getInvoiceQueriesSuccess(response.data));
    } catch (e) {
        message.error(e.response ? e.response.data.message : e);
        yield put(getInvoiceQueriesFailure(e.response ? e.response.data.message : e));
    }
}

function* postComment({ payload }) {
    const customerId = getCustomerIdFromCookie();
    try {
        const response = yield call(fetchApiAuth, {
            method: 'POST',
            url: `invoice-query/${payload.invoiceQueryId}/comment`,
            body: {
                comment: payload.comment,
                customerId,
            },
        });

        yield put(postCommentSuccess(response.data));
        message.success('Successfully posted comment');
    } catch (e) {
        message.error(e.response ? e.response.data.message : e);
        yield put(postCommentFailure(e.response ? e.response.data.message : e));
    }
}

/**
 * Watch actions
 */
export default function* invoiceSaga() {
    yield all([
        takeEvery(RAISE_INVOICE_QUERY_REQUEST, raiseInvoiceQuery),
        takeEvery(RAISE_INVOICE_QUERY_WP_REQUEST, raiseWPInvoiceQuery),
        takeEvery(ACCEPT_INVOICE_QUERY_WP_REQUEST, acceptWPInvoiceQuery),
        takeEvery(ADD_INVOICE_COMMENT_WP_REQUEST, addWPInvoiceComments),
        takeEvery(GET_INVOICE_QUERIES_REQUEST, getInvoiceQueries),
        takeEvery(GET_INVOICE_QUERY_REQUEST, getInvoiceQuery),
        takeEvery(POST_COMMENT_REQUEST, postComment),
    ]);
}
